import { PaymentStatus } from '@/types/payment';
import { PaymentGroupStage } from '@/types/payment-groups';

export const PAYMENT_GROUP_STATUS_TO_STAGE_MAPPER: Record<
  PaymentStatus,
  PaymentGroupStage
> = {
  [PaymentStatus.Authorized]: PaymentGroupStage.AWAITING_PAYMENT,
  [PaymentStatus.Pending]: PaymentGroupStage.AWAITING_PAYMENT,
  [PaymentStatus.InCheckout]: PaymentGroupStage.IN_PROGRESS,
  [PaymentStatus.WaitingFunds]: PaymentGroupStage.IN_PROGRESS,
  [PaymentStatus.Expired]: PaymentGroupStage.FAILED,
  [PaymentStatus.Failed]: PaymentGroupStage.FAILED,
  [PaymentStatus.Paid]: PaymentGroupStage.COMPLETED,
};

export const PAYMENT_GROUP_STAGE_TO_STATUS_MAPPER: Record<
  PaymentGroupStage,
  PaymentStatus[]
> = Object.values(PaymentGroupStage).reduce(
  (acc, stage) => {
    acc[stage] = Object.entries(PAYMENT_GROUP_STATUS_TO_STAGE_MAPPER)
      .filter(([, mappedStage]) => mappedStage === stage)
      .map(([status]) => status as PaymentStatus);
    return acc;
  },
  {} as Record<PaymentGroupStage, PaymentStatus[]>,
);
